import * as Sentry from '@sentry/vue';
import { SentryErrorQueue } from './errorQueue';
import { setupResourceErrorHandlers, setupConnectionHandlers } from './handlers';

export function initSentry(app) {
    console.log(import.meta.env);
    if (import.meta.env.MODE !== 'production') return;
    // Инициализация очереди
    SentryErrorQueue.init();

    // Инициализация Sentry
    window.Sentry = Sentry;
    Sentry.init({
        app,
        dsn: "https://d24e5837417a475c98ef348f94525974@glitchtip.batnorton.com/3",
        environment: import.meta.env.MODE, // Указываем окружение
        sendDefaultPii: true,
        beforeSend(event) {
           // Добавляем информацию о соединении
            event.extra = event.extra || {};
            event.extra.connection = {
                online: navigator.onLine,
                effectiveType: navigator.connection?.effectiveType,
                saveData: navigator.connection?.saveData
            };
            return event;
        }
    });

    // Настройка обработчиков
    setupResourceErrorHandlers();
    setupConnectionHandlers();

    // Тестовая функция
    window.testSentryError = () => {
        const err = new Error('Тестовая ошибка Sentry');
        try {
            throw err;
        } catch (e) {
            if (navigator.onLine) {
                Sentry.captureException(err);
            } else {
                SentryErrorQueue.add({
                    type: 'exception',
                    error: err,
                    options: { tags: { test: true } }
                });
                console.log('Ошибка сохранена в очередь (нет интернета)');
            }
        }
    };
}
